
import React from "react";
import { Sprout } from "lucide-react";

const WhatSection = () => {
  return (
    <section className="py-16 container">
      <div className="max-w-3xl mx-auto">
        <div className="inline-flex items-center px-4 py-2 rounded-full bg-earth-100 mb-6">
          <Sprout className="w-5 h-5 text-eco-500 mr-2" />
          <span className="font-semibold text-eco-700">What</span>
        </div>
        <h2 className="text-3xl font-bold mb-6 text-eco-700">
          A digital map of sustainable living across Britain
        </h2>
        <p className="text-lg text-muted-foreground mb-6">
          A digital map and directory where you can explore alternative businesses, ethical events, 
          eco-friendly products and community-led spaces across Britain.
        </p>
        <p className="text-lg text-muted-foreground mb-6">
          A place to discover what's happening near you or further afield. A way to connect, 
          share and support the kind of world you'd actually like to live in.
        </p>
        <p className="text-lg text-muted-foreground mb-12">
          We're currently registering as a CIC in the UK. Until then, you're welcome to 
          poke around and see what's growing.
        </p>
      </div>
    </section>
  );
};

export default WhatSection;
